import { version } from '../../package.json';
export default version;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.3.3@antd/es/version/index.js
// module id = 946
// module chunks = 0